const PRACTICE_VIEW_KEY = 'doroparty:raid-practice:view:v1';
const PRACTICE_VIEWS = new Set(['mine', 'union']);

function readPracticeView() {
  if (typeof window === 'undefined') return 'mine';
  try {
    const value = window.sessionStorage.getItem(PRACTICE_VIEW_KEY);
    return PRACTICE_VIEWS.has(value) ? value : 'mine';
  } catch {
    return 'mine';
  }
}

function writePracticeView(value) {
  if (typeof window === 'undefined' || !PRACTICE_VIEWS.has(value)) return;
  try {
    window.sessionStorage.setItem(PRACTICE_VIEW_KEY, value);
  } catch {
    // Storage can be unavailable in private/restricted browser contexts.
  }
}

function practiceViewFromButton(button) {
  const label = String(button?.textContent || '').trim();
  return label.includes('내 모의전 보기') ? 'union' : 'mine';
}

function nextPracticeViewFromButton(button) {
  return practiceViewFromButton(button) === 'mine' ? 'union' : 'mine';
}

export function installRaidControlViewPersistence() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return () => {};

  let frame = 0;

  const restorePracticeView = () => {
    frame = 0;
    const saved = readPracticeView();
    document.querySelectorAll('.practice-view-switch').forEach((button) => {
      if (practiceViewFromButton(button) === saved) return;
      button.click();
    });
  };

  const scheduleRestore = () => {
    if (frame) return;
    frame = window.requestAnimationFrame(restorePracticeView);
  };

  const onClick = (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const button = target?.closest?.('.practice-view-switch');
    if (!button) return;
    writePracticeView(nextPracticeViewFromButton(button));
  };

  document.addEventListener('click', onClick, true);
  const observer = new MutationObserver(scheduleRestore);
  observer.observe(document.documentElement, { childList: true, subtree: true });
  scheduleRestore();

  return () => {
    document.removeEventListener('click', onClick, true);
    observer.disconnect();
    if (frame) window.cancelAnimationFrame(frame);
  };
}
